// Author XXL
// Date 2021-03-19 18:47:32

class SithMesStoolPrPoList {
constructor({
        id = null,
        poNumber = '',
        poItem = '',
        poItemDlvDate = '',
        prNumber = '',
        prItem = '',
        prItemDlvDate = '',
        material = '',
        purchaseGroup = '',
        remark = ''}
= {}) {
    this.id = id;
    this.poNumber = poNumber;
    this.poItem = poItem;
    this.poItemDlvDate = poItemDlvDate;
    this.prNumber = prNumber;
    this.prItem = prItem;
    this.prItemDlvDate = prItemDlvDate;
    this.material = material;
    this.purchaseGroup = purchaseGroup;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesStoolPrPoList();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'poNumber',
        label: 'label.sith.stool.sithMesStoolPrPoList.grid.poNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'poItem',
        label: 'label.sith.stool.sithMesStoolPrPoList.grid.poItem',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'poItemDlvDate',
        label: 'label.sith.stool.sithMesStoolPrPoList.grid.poItemDlvDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prNumber',
        label: 'label.sith.stool.sithMesStoolPrPoList.grid.prNumber',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prItem',
        label: 'label.sith.stool.sithMesStoolPrPoList.grid.prItem',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prItemDlvDate',
        label: 'label.sith.stool.sithMesStoolPrPoList.grid.prItemDlvDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'material',
        label: 'label.sith.stool.sithMesStoolPrPoList.grid.material',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'purchaseGroup',
        label: 'label.sith.stool.sithMesStoolPrPoList.grid.purchaseGroup',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPrPoList.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    poNumberFilter : "",
    poItemFilter : "",
    poItemDlvDateRteFilter : "",
    poItemDlvDateLteFilter : "",
    prNumberFilter : "",
    prItemFilter : "",
    prItemDlvDateRteFilter : "",
    prItemDlvDateLteFilter : "",
    materialFilter : "",
    purchaseGroupFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'poNumberFilter',
        label: 'label.sith.stool.sithMesStoolPrPoList.filter.poNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'poItemFilter',
        label: 'label.sith.stool.sithMesStoolPrPoList.filter.poItem',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'poItemDlvDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrPoList.filter.poItemDlvDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'poItemDlvDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrPoList.filter.poItemDlvDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'prNumberFilter',
        label: 'label.sith.stool.sithMesStoolPrPoList.filter.prNumber',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prItemFilter',
        label: 'label.sith.stool.sithMesStoolPrPoList.filter.prItem',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prItemDlvDateRteFilter',
        label: 'label.sith.stool.sithMesStoolPrPoList.filter.prItemDlvDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'prItemDlvDateLteFilter',
        label: 'label.sith.stool.sithMesStoolPrPoList.filter.prItemDlvDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'materialFilter',
        label: 'label.sith.stool.sithMesStoolPrPoList.filter.material',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'purchaseGroupFilter',
        label: 'label.sith.stool.sithMesStoolPrPoList.filter.purchaseGroup',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'poNumber',
        label: 'label.sith.stool.sithMesStoolPrPoList.entity.poNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'poItem',
        label: 'label.sith.stool.sithMesStoolPrPoList.entity.poItem',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'poItemDlvDate',
        label: 'label.sith.stool.sithMesStoolPrPoList.entity.poItemDlvDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'prNumber',
        label: 'label.sith.stool.sithMesStoolPrPoList.entity.prNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prItem',
        label: 'label.sith.stool.sithMesStoolPrPoList.entity.prItem',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'prItemDlvDate',
        label: 'label.sith.stool.sithMesStoolPrPoList.entity.prItemDlvDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'material',
        label: 'label.sith.stool.sithMesStoolPrPoList.entity.material',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'purchaseGroup',
        label: 'label.sith.stool.sithMesStoolPrPoList.entity.purchaseGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolPrPoList.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesStoolPrPoList, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
